import React from 'react'
import { Typography } from '@telavita-core/react-design-kit'

import { ReactComponent as CheckIcon } from 'static/svg/icon-check-green.svg'
import { ReactComponent as CloseIcon } from 'static/svg/icon-close.svg'

import { SelectOptionBannerStateProps } from './types'

import * as S from './styles'

export const SelectWhatsAppBannerState: React.FC<SelectOptionBannerStateProps> = ({ handleCloseBanner }) => (
  <S.ContentSelectedWrapper>
    <CheckIcon width={24} height={24} />
    <S.Content>
      <Typography variant="content2">
        Pronto! Enviaremos lembretes das suas próximas consultas por WhatsApp.
      </Typography>
      <Typography variant="content2">
        Caso queira modificar, é só acessar a opção <strong>Configurações</strong> no menu.
      </Typography>
    </S.Content>

    <CloseIcon role="button" onClick={handleCloseBanner} />
  </S.ContentSelectedWrapper>
)